import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/kavove-predplatne" as const,
	[Locale.en]: "/coffee-subscription" as const,
} satisfies LocalizedString;

export function getSubscriptionPagePath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
